import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import type { AnalyticsErrorInfo, AnalyticsMeta } from './types';

export const onFireErrorEvent = (error: Error, info: AnalyticsErrorInfo, meta?: AnalyticsMeta) =>
	fireErrorAnalytics({
		error,
		sendToPrivacyUnsafeSplunk: true,
		meta: meta || {
			id: 'unhandled',
			packageName: 'jiraProjectPagesErrorEventUtil',
			teamName: 'confluence-better-together',
		},
	});
